class PlpLayoutSwitch extends HTMLElement {
  constructor() {
    super();
    this.layoutKey = 'plpLayout';
    this.defaultLayout = 'list';
    this.buttons = [];
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('.navigation--layout-button');
    this.collectionContainer = document.querySelector('#ProductGridContainer .collection');

    if (!this.collectionContainer) return;

    if (!localStorage.getItem(this.layoutKey)) {
      localStorage.setItem(this.layoutKey, this.defaultLayout);
    }

    this.applyLayout(localStorage.getItem(this.layoutKey));
    this.addListeners();
  }

  applyLayout(layout) {
    this.collectionContainer.classList.remove('list', 'grid');
    this.collectionContainer.classList.add(layout);

    this.buttons.forEach((btn, index) => {
      const isList = index === 0;
      const isActive = (layout === 'list' && isList) || (layout === 'grid' && !isList);
      btn.classList.toggle('active', isActive);
      btn.setAttribute('data-active', isActive);
    });
  }

  addListeners() {
    this.buttons.forEach((btn, index) => {
      const layout = index === 0 ? 'list' : 'grid';

      const handler = () => {
        localStorage.setItem(this.layoutKey, layout);
        this.applyLayout(layout);
      };

      btn.addEventListener('click', handler);
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') handler();
      });
    });
  }
}

customElements.define('plp-layout-switch', PlpLayoutSwitch);


class CDXLieferumfang extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const triggers = this.querySelectorAll(".component_el_modal_trigger");
    const closeButtons = this.querySelectorAll(".component_el_modal_close");
    const backgrounds = this.querySelectorAll(".component_el_modal_bg");

    // Trigger öffnen
    triggers.forEach(trigger => {
      trigger.addEventListener("click", (event) => {
        const modalId = event.currentTarget.getAttribute("data-loop-modal");
        this.openModal(modalId);
      });
    });

    // Close-Buttons schließen
    closeButtons.forEach(closeBtn => {
      closeBtn.addEventListener("click", (event) => {
        const modal = event.currentTarget.closest(".component_el_modal");
        if (modal) this.closeModal(modal);
      });
    });

    // Klick auf Hintergrund schließen
    backgrounds.forEach(bg => {
      bg.addEventListener("click", (event) => {
        const modal = event.currentTarget.closest(".component_el_modal");
        if (modal) this.closeModal(modal);
      });
    });
  }

  openModal(modalId) {
    // alle schließen
    this.querySelectorAll(".component_el_modal").forEach(m => m.classList.add("hidden"));
    // das passende öffnen
    const modal = this.querySelector(`.component_el_modal[data-loop-modal="${modalId}"]`);
    if (modal) {
      modal.classList.remove("hidden");
      document.body.classList.add("modal-open"); // Body scroll sperren
    }
  }

  closeModal(modalEl) {
    modalEl.classList.add("hidden");
    document.body.classList.remove("modal-open"); // Body scroll wieder erlauben
  }
}

customElements.define("cdx-lieferumfang", CDXLieferumfang);

